const theme = isDark => ({
  mobileBreakpoint: '500px',

  primary: {
    red: '#f44336',
    pink: '#e91e63',
    purple: '#9c27b0',
    deep_purple: '#673ab7',
    indigo: '#3f51b5',
    blue: '#2196f3',
    light_blue: '#03a9f4',
    cyan: '#00bcd4',
    teal: '#009688',
    green: '#4caf50',
    light_green: '#8bc34a',
    lime: '#cddc39',
    yellow: '#ffeb3b',
    amber: '#ffc107',
    orange: '#ff9800',
    deep_orange: '#ff5722',
    brown: '#795548',
    blue_gray: '#607d8b',
  },
  [isDark ? 'primaryDark' : 'primaryLight']: {
    red: '#FFEBEE',
    pink: '#FCE4EC',
    purple: '#F3E5F5',
    deep_purple: '#EDE7F6',
    indigo: '#E8EAF6',
    blue: '#E3F2FD',
    light_blue: '#E1F5FE',
    cyan: '#E0F7FA',
    teal: '#E0F2F1',
    green: '#E8F5E9',
    light_green: '#F1F8E9',
    lime: '#F9FBE7',
    yellow: '#FFFDE7',
    amber: '#FFF8E1',
    orange: '#FFF3E0',
    deep_orange: '#FBE9E7',
    brown: '#EFEBE9',
    blue_gray: '#ECEFF1',
  },
  [isDark ? 'primaryLight' : 'primaryDark']: {
    red: '#490804',
    pink: '#46071c',
    purple: '#370e3f',
    deep_purple: '#21123a',
    indigo: '#141939',
    blue: '#042a49',
    light_blue: '#01344c',
    cyan: '#00444d',
    teal: '#003d37',
    green: '#173518',
    light_green: '#283913',
    lime: '#3c410b',
    yellow: '#332e00',
    amber: '#473600',
    orange: '#4d2e00',
    deep_orange: '#4d1200',
    brown: '#30221d',
    blue_gray: '#1f292d',
  },

  theme: 'light',
  background: '#FFFFFF',
  text: '#222222',
  menuHighlight: '#DDDDDD',

  ...isDark && {
    theme: 'dark',
    background: '#111111',
    text: '#EEEEEE',
    menuHighlight: '#444444',
  }
})

export { default as globalStyles } from './globalStyles'

export default theme